import { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { BsCheckAll } from "react-icons/bs";
import { FiLoader } from "react-icons/fi";
import { ImCross } from "react-icons/im";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";

const Verify = () => {
  const { token } = useParams();
  const { backendURL } = useContext(PitchContext);
  const [verify, setVerify] = useState();
  const [pending, setPending] = useState();
  const [message, setMessage] = useState();

  const verifyUser = () => {
    setPending(true);
    axios
      .post(backendURL + `user/verify/${token}`, {})
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setVerify(true);
          setMessage(response.data.message);
          axios
            .post(backendURL + "payment/create-submerchant", {
              user: JSON.stringify(response.data.user),
            })
            .then((_) => {
              console.log("merchant created");
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          setVerify(false);
          setMessage(response.data.message);
        }
      })
      .catch((err) => {
        setVerify(false);
        setPending(false);
        console.log(err.response.data.message);
        setMessage(err.response.data.message);
      });
  };

  useEffect(() => {
    verifyUser();
  }, []);

  if (pending) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md bg-gray-500 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
          <div className="text-center p-6 sm:p-8 text-white space-y-4 animate-fade-in">
            <h2 className="text-2xl sm:text-3xl font-semibold tracking-wide">
              E-posta Doğrulama
            </h2>
            <p className="text-base sm:text-lg font-light">Doğrulanıyor...</p>
            <div className="text-6xl sm:text-9xl text-white/90 flex justify-center">
              <FiLoader className="animate-spin" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="my-20 sm:my-0 sm:min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div
        className={`w-full max-w-md ${
          verify
            ? "bg-gradient-to-br from-[#6ca87e] to-[#5b926b]"
            : "bg-red-500"
        } rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300`}
      >
        <div className="text-center p-6 sm:p-8 text-white space-y-4 animate-fade-in">
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-wide">
            E-posta Doğrulama
          </h2>
          <p className="text-base sm:text-lg font-light">{message}</p>
          <div className="text-6xl sm:text-9xl text-white/90 flex justify-center">
            {verify ? (
              <BsCheckAll className="animate-pulse" />
            ) : (
              <ImCross className="animate-pulse" />
            )}
          </div>
          <Link to={"/"}>
            <button className="bg-white text-black rounded-lg px-4 py-2 sm:px-5 sm:py-3 cursor-pointer hover:bg-gray-200 mt-6 sm:mt-10 text-sm sm:text-base">
              Ana Sayfaya Git
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Verify;
